import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ContentSectionComponent } from './content-section.component';

@NgModule({
	declarations: [ContentSectionComponent],
	imports: [
		CommonModule,
	],
	exports: [ContentSectionComponent],
})
export class ContentSectionModule { }
